import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import { EoFormComponent, STATUS } from 'ngx-eo-web-components';
import { filter, Subscription } from 'rxjs';
import { surgeryCancelFormConfig } from '../../config/surgery-cancel-form.config';
import { CoreService } from '../../../core/core.service';
import { SurgeryService } from '../../../../services/surgery/surgery.service';
import { Surgery } from '../../../core/models/surgery.model';
import { Validators } from '@angular/forms';
import { OptionService } from '../../../../services/option/option-service.service';
import { Option } from '../../../core/models/option.model';
import { ConfirmationService, Message } from 'primeng/api';

@Component({
  selector: 'app-surgery-cancel-form-dialog',
  templateUrl: './surgery-cancel-form-dialog.component.html',
  styleUrls: ['./surgery-cancel-form-dialog.component.scss'],
})
export class SurgeryCancelFormDialogComponent {
  optionListCallHandler = this.optionService.optionListCallHandler;

  isFetchSurgeryCancelReasonsLoading(): boolean {
    return this.optionListCallHandler.status$.getValue() === STATUS.loading;
  }

  surgeryCancelReasons: Option[] | null = null;

  messages: Message[] = [];

  constructor(
    private surgeryService: SurgeryService,
    private coreService: CoreService,
    private optionService: OptionService
  ) {}

  subscriptions: Subscription[] = [];

  @ViewChild('eoForm', { static: false }) eoForm?: EoFormComponent;

  surgery?: Surgery;

  visible = false;
  formConfig = [...surgeryCancelFormConfig];

  @Output() success = new EventEmitter();

  ngOnInit(): void {
    this.subscriptions = [this.getSurgeryCancelSuccessSub$()];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((s) => s.unsubscribe());
  }

  onSubmit($event: any) {
    if (!$event?.surgeryCancelForm) return;

    let surgeryCancelBind = {
      surgeryID: this.surgery?.id ?? '',
      surgeryCancelReasonOptionID:
        $event?.surgeryCancelForm.surgeryCancelReasonOptionID,
      surgeryCancelComments: $event?.surgeryCancelForm.surgeryCancelComments,
    };

    this.surgeryService.cancelSurgery(surgeryCancelBind).subscribe();
  }

  onSubmitSuccess(): void {
    this.surgeryService.init();
    this.visible = false;
    this.showSuccessMessage();
    this.success.emit();
  }

  showSuccessMessage(): void {
    this.coreService.showSuccess('Η ακύρωση ολοκληρώθηκε με επιτυχία');
  }

  setFcValue(formControlName: string, value: any) {
    return this.eoForm?.setValue('surgeryCancelForm', formControlName, value);
  }

  getFormConfig() {
    return this.formConfig;
  }

  getHeader(): string {
    return 'Ακύρωση Χειρουργείου';
  }

  initForm() {
    this.eoForm?.form.reset();
    this.eoForm?.form.enable();

    if (this.surgery) {
    }
  }

  getSurgeryCancelSuccessSub$() {
    return this.surgeryService.surgeryCancelCallHandler.status$
      .pipe(filter((s) => s === STATUS.success))
      .subscribe(() => {
        this.onSubmitSuccess();
      });
  }

  fetchSurgeryCancelReasons() {
    this.optionService.getOptions('surgery-cancel-reason').subscribe((data) => {
      this.surgeryCancelReasons = data;

      // Move options with optionTypeAlias === 'other' to the end of the list
      const otherOptions = this.surgeryCancelReasons.filter(
        (option) => option.optionTypeAlias === 'other'
      );
      this.surgeryCancelReasons = this.surgeryCancelReasons
        .filter((option) => option.optionTypeAlias !== 'other')
        .concat(otherOptions);
    });
  }

  isSubmitLoading(): boolean {
    let sCancelStatus =
      this.surgeryService.surgeryCancelCallHandler?.status$?.getValue();
    if (sCancelStatus === STATUS.loading) return true;

    return false;
  }

  show(surgery?: Surgery): void {
    this.surgery = surgery;
    this.initForm();
    this.visible = true;
    this.fetchSurgeryCancelReasons();
    this.messages = [
      {
        severity: 'error',
        detail:
          'Προσοχή! Είστε σίγουροι ότι θέλετε να ακυρώσετε το συγκεκριμένο χειρουργείο; Η ενέργεια είναι αμετάκλητη.',
      }
    ];
  }

  updateSurgeryCancelCommentsValidator() {
    const surgeryCancelReasonControl = this.eoForm?.getFormControl(
      'surgeryCancelForm',
      'surgeryCancelReasonOptionID'
    );
    const surgeryCancelCommentsControl = this.eoForm?.getFormControl(
      'surgeryCancelForm',
      'surgeryCancelComments'
    );

    if (surgeryCancelReasonControl && surgeryCancelCommentsControl) {
      const selectedReason = this.surgeryCancelReasons?.find(
        (reason) => reason.id === surgeryCancelReasonControl.value
      );

      if (selectedReason?.optionTypeAlias === 'other') {
        surgeryCancelCommentsControl.setValidators([Validators.required]);
      } else {
        surgeryCancelCommentsControl.clearValidators();
      }
      surgeryCancelCommentsControl.updateValueAndValidity();
    }
  }
}
